<template>
    <div class="w-full">
      <vx-card id="bulkUploadScheduleCard" title="">
        <div class="vx-row">
          <div class="vx-col">
            <div class="flex flex-wrap items-center justify-center">
              <div class="vs-con-loading__container">
                <v-uploader v-show="!isBulkAddHidden && !bulkCsvFileUrl" @done="csvSuccessUpload" ref="bulkUpload" file-type-exts="csv" button-text="Upload .csv file" language="en" file-size-limit="100MB" :preview="false"></v-uploader>
                
              </div>
              <vs-button v-show="bulkCsvFileUrl" ref="confirmBulkButton" color="success" size="small" class="mb-4 mr-3" @click="confirmBulkScheduleUpload">Add Schedules</vs-button>
              <vs-button v-show="!isBulkAddHidden && canCancel" color="warning" size="small" class="mb-4 ml-3" @click="cancelBulkAdd">Cancel</vs-button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<vs-button ref="processBulkButton" color="warning" size="small" class="mb-4 mr-3" @click="process">Process</vs-button>
              <vs-button type="border" size="small" class="mb-4 ml-3" @click="downloadTemplate">Get Template</vs-button>
              
            </div>
          </div>
        </div>
        <vs-table stripe ref="bulkSchedulesTable" class="vs-con-loading__container" single pagination :max-items="itemsPerPage" search :data="bulkSchedules">

          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ bulkSchedules.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : bulkSchedules.length }} of {{ bulkSchedules.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=200">
                  <span>200</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=300">
                  <span>300</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=500">
                  <span>500</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=1000">
                  <span>1000</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
  
          <template slot="thead">
            <vs-th sort-key="name">Module</vs-th>
            <vs-th sort-key="fromDate">From Date</vs-th>
            <vs-th sort-key="toDate">To Date</vs-th>
            <vs-th sort-key="processingException">Processing Exception</vs-th>
            <vs-th sort-key="createDt">Create Date</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="bulkSchedule" :state="bulkSchedule.processingException ? 'danger' : bulkSchedule.processed? 'success' : 'warning'" :key="indextr" v-for="(bulkSchedule, indextr) in data">

              <vs-td :data="data[indextr].module">
                {{ bulkSchedule.module ? bulkSchedule.module : "n/a" }}
              </vs-td>

              <vs-td :data="data[indextr].fromDate">
                {{ bulkSchedule.fromDate }}
              </vs-td>
              
              <vs-td :data="data[indextr].toDate">
                {{ bulkSchedule.toDate }}
              </vs-td>

              <vs-td :data="data[indextr].processingException">
                {{ bulkSchedule.processingException ? bulkSchedule.processingException : "No exception" }}
              </vs-td>

              <vs-td :data="data[indextr].createDt">
                {{ bulkSchedule.createDt.replace("T", " ").split('.')[0] }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>

  export default {
    data() {
      return {
        selected: [],
        isBulkAddHidden: false,
        bulkCsvFileUrl: "",
        canCancel: false,
        isLoading: false,
        bulkSchedules: [],
        itemsPerPage: 300,
        isMounted: false,
        wasSidebarOpen: false
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.bulkSchedulesTable.currentx;
        }
        return 0;
      }
    },
    methods: {
      csvSuccessUpload(data) {
        this.isLoading = false;
        this.canCancel = true;
        this.bulkCsvFileUrl = data[0].url;
      },
      confirmBulkScheduleUpload() {
        var self = this;
        self.canCancel = false;
        self.showLoadingOnElement('confirmBulkButton', 0.35, 'material');

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: response.data,
            time: 7000,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
          self.loadBulkScheduleData();
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.confirmBulkButton.$el);
          self.cancelBulkAdd();
        };
        
        self.$ajaxGet(self, "BulkUploadSchedule/Upload?fileUrl=" + self.bulkCsvFileUrl, onSuccess, onFinally);

      },
      downloadTemplate(){
        var self = this;
        window.open("https://lateralscaffolding.blob.core.windows.net/studentbulk/Template_BulkUpload_schedual.xlsx");
      },
      process() {
        var self = this;
        self.showLoadingOnElement('processBulkButton', 0.35, 'material');

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: response.data,
            time: 7000,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
          self.loadBulkScheduleData();
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.processBulkButton.$el);
        };
        
        self.$ajaxGet(self, "BulkUploadSchedule/process", onSuccess, onFinally);

      },
      cancelBulkAdd() {
        this.isLoading = false;
        this.isBulkAddHidden = false;
        this.bulkCsvFileUrl = "";
        this.canCancel = false;
        this.$vs.loading.close(this.$refs.bulkUpload.$el);
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      loadBulkScheduleData() {
        const self = this;
        self.showLoadingOnElement('bulkSchedulesTable', 1, 'corners')

        var onSuccess = function(response) {
          self.bulkSchedules = response.data;
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.bulkSchedulesTable.$el);
        };

        self.$ajaxGet(self, "BulkUploadSchedule/GetBulkUplaodData", onSuccess, onFinally);
      },
      addUploaderClickEvents() {
        var self = this;

        self.$refs.bulkUpload.$el.addEventListener("click", function(){
          if(!self.isLoading) {
            self.isLoading = true;
            self.showLoadingOnElement("bulkUpload", 0.50, "material");
          }else{
            self.isLoading = false;
            self.$vs.loading.close(self.$refs.bulkUpload.$el);
          }
        });
      },
      showLoadingOnTable() {
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.bulkSchedulesTable.$el,
          scale: 1
        });
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
    },
    mounted() {
      var self = this;
      self.wasSidebarOpen = this.$store.state.reduceButton;
      self.isMounted = true;
      self.addUploaderClickEvents();
      self.showLoadingOnTable();
      self.loadBulkScheduleData();
      // document.getElementsByClassName("input-search")[0].innerText = "";
      // self.$refs.bulkSchedulesTable.searchx = "";
      self.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    },
    beforeDestroy() {
      if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
    }
  }

</script>
<style lang="scss">
  div.btn.singleFileUpload.uploader-button {
    padding: 10px !important;
    border-radius: 30px !important;
    background-color: rgb(40, 199, 111) !important;
    color: rgb(255, 255, 255) !important;
    font-size: 15px !important;
    font-variant: small-caps !important;
    font-weight: 600 !important;
  }

  div.v-uploader {
    .vs-con-loading__container .con-vs-loading {
      top: 38% !important;
    }
  }
</style>
